const modalities = ['CR', 'DX', 'US', 'CT', 'MR', 'MG', 'XA'];

export default modalities;
